import Text from "../../../Components/Text";
import Websocket from "../../../Helper/Websocket"
import React, { useState, useEffect, useRef } from "react";
import StripePayment from "../../../Components/StripePayment";
import BackButton from "../../../Components/Buttons/Variants/BackButton";

const PaymentTerminal = ({ }) => {
    const params = new URLSearchParams(window.location.search);
    const [randomId, setRandomId] = useState(params.get("deviceId"))
    const [paymentAmount, setPaymentAmount] = useState(null)
    const { subscribe } = Websocket()


    useEffect(() => {
        if (!randomId) {
            setRandomId(Math.floor(1000 + Math.random() * 9000));
        }
    }, []);

    useEffect(() => {
        if (randomId === null) return;
        subscribe({ socket: `payment/${randomId}`, action: (msg) => { setPaymentAmount(msg.body) } });
    }, [randomId, subscribe]);

    return (
        <div className="w-full flex flex-col">
            <div className="w-full flex flex-col px-5 py-2 gap-3 items-center">
                <div className=" flex flex-row justify-start ">
                    <BackButton />
                </div>
                <div className="w-full flex flex-col text-center justify-center gap-3">
                    <Text type="maintitle"> Bezahlterminal ID {randomId} </Text>

                    {paymentAmount !== null ? (<>
                        <Text type="maintitle">{paymentAmount / 100} CHF</Text>
                        <StripePayment amount={paymentAmount} deviceId={randomId} />
                    </>

                    ) : (
                        <Text type="itemmain">Warte auf Zahlungsaufforderung</Text>
                    )}
                </div>
            </div>

        </div>
    )
}
export default PaymentTerminal